import LatestNews from './LatestNews';
import NewsChildren from './NewsChildren';

export const NewsChild = NewsChildren;

export { LatestNews };
